import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

export const HeroSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="container mx-auto text-center max-w-5xl"
      >
        {/* Badge */}
        <motion.div variants={itemVariants} className="inline-flex items-center gap-2 glass rounded-full px-4 py-2 mb-8">
          <Sparkles className="h-4 w-4 text-primary" />
          <span className="text-sm font-medium">Comunidade Descentralizada e Gamificada</span>
        </motion.div>

        {/* Main Headline */}
        <motion.h1
          variants={itemVariants}
          className="text-4xl sm:text-5xl lg:text-7xl font-bold mb-6 leading-tight"
        >
          <span className="gradient-text">Construa o Futuro</span>
          <br />
          <span className="text-foreground">da Web3 na Confraria</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          variants={itemVariants}
          className="text-base sm:text-lg lg:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed"
        >
          Junte-se à comunidade mais inovadora de Web3 do Brasil. 
          Aprenda, ensine e evolua com gamificação, mentorias e eventos exclusivos.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          variants={itemVariants}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Button 
            size="lg"
            className="bg-primary hover:bg-primary-glow text-primary-foreground font-semibold glow-hover group w-full sm:w-auto"
            onClick={() => window.open('https://ai.eco.br/plans/1956939?bundle_token=98b0c0c2a2973b00d7c39ae8a2114a1a&utm_source=manual', '_blank')}
          >
            Torne-se Membro Mantenedor
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button 
            size="lg"
            variant="outline"
            className="glass border-primary/50 text-foreground hover:bg-primary/10 w-full sm:w-auto"
            onClick={() => window.open('https://ai.eco.br/plans/1932767?bundle_token=d0864b27e6b368a32275f3cebaf7e576&utm_source=manual', '_blank')}
          >
            Participar da Oficina
          </Button>
        </motion.div>

        {/* Price Badge */}
        <motion.div
          variants={itemVariants}
          className="mt-8 inline-flex items-center gap-2 text-sm text-muted-foreground"
        >
          <span className="text-primary font-bold text-2xl">R$ 79</span>
          <span>/ano</span>
        </motion.div>

        {/* Floating Elements */}
        <div className="absolute top-1/4 left-10 w-20 h-20 border border-primary/30 rounded-lg rotate-12 animate-float hidden lg:block" />
        <div className="absolute bottom-1/4 right-10 w-16 h-16 border border-accent/30 rounded-full animate-float hidden lg:block" style={{ animationDelay: '1s' }} />
      </motion.div>
    </section>
  );
};

export default HeroSection;